import React, { FC, useContext, useState } from "react";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-enterprise";
import config from "./GridViewTableConfig";
import { useAxios } from "myAxios";
import GridEventProvider from "components/context/GridEventContext";
import { AuthProvider } from "pages";
import { Skeleton } from "@mui/material";
import dynamic from "next/dynamic";
import { useCallingEpsm, useCallingPsm, useCCSE } from "components/portfolio/hooks";
import { FEATURE_KEY } from "constant";
import { useMediaQuery } from "@mui/material";
import { useMetadataByCategory } from "components/summary/hooks";
import { SelectAccount } from "types/summary";
const GridViewTable: FC<{
  isFullScreen: boolean;
  embedded?: boolean;
  playbookId?: string;
  setCollectionColumns: React.Dispatch<React.SetStateAction<string[]>>;
  setAOVCollectionColumns: React.Dispatch<React.SetStateAction<string[]>>;
  groupCol?: string;
  cavBuId?: number;
  ciscoCsmId?: string;
  fixedAccountId?: string;
  // mutate: () => Promise<void>;
  setTotalSelect: React.Dispatch<React.SetStateAction<SelectAccount[]>>;
  preSelected: string[];
  showAOV?: boolean;
}> = ({
  isFullScreen,
  embedded = false,
  setCollectionColumns,
  setAOVCollectionColumns,
  groupCol = "none",
  cavBuId,
  ciscoCsmId,
  fixedAccountId,
  // mutate,
  setTotalSelect,
  preSelected,
  showAOV,
}) => {
  const axios = useAxios();
  const { setGridEvent } = useContext(GridEventProvider);
  const authDetail = useContext(AuthProvider);
  const [_, setExpandedGroups] = useState<string[]>([]);
  const editTae = embedded ? false : authDetail.features.includes(FEATURE_KEY.PORTFOLIO_EDIT_TAE);
  const editPsm = embedded
    ? false
    : authDetail.features.includes(FEATURE_KEY.PORTFOLIO_EDIT_CALLING_PSM);

  const { data: ccse, error: ccseError } = useCCSE(editTae);
  const { data: callingEpsm, error: epsmError } = useCallingEpsm(editPsm);
  const { data: callingPsm, error: psmError } = useCallingPsm(editPsm);

  const { data: eventMappings, error: eventError } = useMetadataByCategory("RENEWAL_FACTORS");
  const { data: workloadCategory, error: wcError } = useMetadataByCategory("WORKLOAD");
  const { data: workloadStage, error: wsError } = useMetadataByCategory("WORKLOAD_LIFECYCLE_STAGE");

  const smallScreen = useMediaQuery("(max-width:1280px)");
  const topMenuMedia = useMediaQuery("(min-width:600px)");
  const isFixfox = navigator.userAgent.indexOf("Firefox") > -1;

  const getFullScreenTableHeight = () => {
    let height = "100%";
    if (isFullScreen) {
      if (isFixfox) {
        !topMenuMedia ? (height = "calc(100vh - 102px)") : (height = "calc(100vh - 120px)");
      } else {
        if (!topMenuMedia) {
          height = "calc(150vh - 102px)";
        }
        if (topMenuMedia && smallScreen) {
          height = "calc(150vh - 120px)";
        }
        if (!smallScreen) {
          height = "calc(100vh - 120px)";
        }
      }
    } else if (embedded) {
      height = "calc(100% - 22px)";
    } else {
      height = "100%";
    }
    return height;
  };
  const height = getFullScreenTableHeight();

  return (
    <div
      className="ag-theme-material"
      style={{
        height,
        width: "100%",
        border: isFullScreen ? "unset" : "1px solid #DEDEDE",
      }}
    >
      {((editTae && (ccse || ccseError)) || !editTae) &&
      (!editPsm || (editPsm && (callingEpsm || epsmError))) &&
      (!editPsm || (editPsm && (callingPsm || psmError))) &&
      (eventMappings || eventError) &&
      (workloadCategory || wcError) &&
      (workloadStage || wsError) ? (
        <AgGridReact
          {...config(
            axios,
            setGridEvent,
            authDetail,
            editTae ? (ccse ?? []) : [],
            editPsm ? (callingEpsm ?? []) : [],
            editPsm ? (callingPsm ?? []) : [],
            eventMappings ?? [],
            workloadCategory ?? [],
            workloadStage ?? [],
            embedded,
            setCollectionColumns,
            setAOVCollectionColumns,
            groupCol,
            setExpandedGroups,
            cavBuId,
            ciscoCsmId,
            fixedAccountId,
            // mutate,
            setTotalSelect,
            preSelected,
            showAOV
          )}
        />
      ) : null}
    </div>
  );
};

export default dynamic(() => Promise.resolve(GridViewTable), {
  ssr: false,
  loading: () => (
    <Skeleton
      variant="rectangular"
      width="100%"
      height="calc(100vh - 235px)"
      style={{ padding: "46px 23px 23px 10px" }}
    />
  ),
});
